import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChevronUp } from 'lucide-react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import BlogArticle from './pages/BlogArticle';
import BlogList from './pages/BlogList';
import LegalPage from './pages/LegalPages';

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <BrowserRouter>
      <div className="font-manjari text-dark bg-background min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow relative">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/:page" element={<LegalPage />} />
          </Routes>
          <div className="fixed inset-0 pointer-events-none">
            <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-background to-transparent z-10"></div>
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background to-transparent z-10"></div>
          </div>
          {showScrollTop && (
            <button
              onClick={scrollToTop}
              className="fixed bottom-6 right-6 bg-[#3087cf] hover:bg-[#3087cf]/90 text-white p-3 rounded-full shadow-lg transition-all duration-300 z-50"
              aria-label="Scroll to top"
            >
              <ChevronUp className="h-6 w-6" />
            </button>
          )}
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;